import { __rest, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { IconBox } from '../IconBox/index.js';

var SliderIconHandle = function (props) {
    var children = props.children, forwardProps = __rest(props, ["children"]);
    return (jsx(IconBox, __assign({ "data-reach-slider-handle-icon": "" }, forwardProps, { children: children })));
};
SliderIconHandle.displayName = "SliderIconHandle";

export { SliderIconHandle };
//# sourceMappingURL=SliderIconHandle.js.map
